































import axios from 'axios'
import { Component } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Event, {IEvent} from '@/models/Event'
import AuthLayout from '@/components/auth/Layout.vue'
import {apiV1EventPath, apiV1UsersSignInPath} from '@/rails/routes'
import EventCard from "@/components/events/Card.vue"

@Component({
  components: {
    AuthLayout,
    EventCard
  }
})
export default class SignInIndex extends VueBase {
  email = ''
  password = ''
  event = new Event()

  async mounted(): Promise<void> {
    if (this.queryParam('event_id')) {
      try {
        const res = await axios.get<IEvent>(apiV1EventPath(this.queryParam('event_id')))
        this.event = new Event(res.data)
      } catch {
      }
    }
  }

  get signUpUrl(): string {
    const url = '/users/sign_up'
    const params = new URLSearchParams(window.location.search).toString()
    return params ? `${url}?${params}` : url
  }

  async login(): Promise<void> {
    try {
      const res = await axios.post(apiV1UsersSignInPath(), {
        user: {
          email: this.email,
          password: this.password
        },
        event_id: this.queryParam('event_id'),
        token: this.queryParam('token')
      })
      if (this.queryParam('back_url')) {
        window.location.href = this.queryParam('back_url')
      } else {
        window.location.href = res.data
      }
    } catch (e) {
      this.showError('メールアドレスまたはパスワードが間違っています')
    }
  }
}
